import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useFetchContacts from "../../../disaster/hooks/useFetchContacts";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useUploadDocument from "../../../disaster/hooks/useUploadDocument";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Legal Documentation Divorce",
  "Marriage Certificate Divorce",
  "Prenuptial Agreement Divorce",
  "Postnuptial Agreement Divorce",
  "Previous Divorce Decrees Divorce",
  "Living Will Divorce",
  "Living Trust Divorce",
  "Power Of Attorney Divorce",
  "Healthcare Directives Divorce",
  "Business Agreements Divorce",
  "Court Orders Divorce",
];

export default function LegalDocumentation() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Legal Documentation");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const { handleImageUpload } = useUploadDocument(setLoading, setFormData);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Legal Documentation": tableData.legalDocumentationData,
    "Marriage Certificate Divorce": tableData.marriageCertificateDivorceData,
    "Prenuptial Agreement Divorce": tableData.prenuptialAgreementDivorceData,
    "Postnuptial Agreement Divorce": tableData.postnuptialAgreementDivorceData,
    "Previous Divorce Decrees Divorce":
      tableData.previousDivorceDecreesDivorceData,
    "Living Will Divorce": tableData.livingWillDivorceData,
    "Living Trust Divorce": tableData.livingTrustDivorceData,
    "Power Of Attorney Divorce": tableData.powerOfAttorneyDivorceData,
    "Healthcare Directives Divorce": tableData.healthcareDirectivesDivorceData,
    "Business Agreements Divorce": tableData.businessAgreementsDivorceData,
    "Court Orders Divorce": tableData.courtOrdersDivorceData,
  };

  const { contactList } = useFetchContacts(setLoading);

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );


  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );



  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);


  const marriageDocumentsTables = [
    {
      title: "Marriage Certificate",
      key: 1,
      backendName: "Marriage Certificate Divorce",
    },
    {
      title: "Prenuptial Agreement",
      key: 2,
      backendName: "Prenuptial Agreement Divorce",
    },
    {
      title: "Postnuptial Agreement",
      key: 3,
      backendName: "Postnuptial Agreement Divorce",
    },
    {
      title: "Previous Divorce Decrees",
      key: 4,
      backendName: "Previous Divorce Decrees Divorce",
    },
  ];

  const legalRecordsTables = [
    { title: "Living Will", key: 5, backendName: "Living Will Divorce" },
    { title: "Living Trust", key: 6, backendName: "Living Trust Divorce" },
    {
      title: "Power Of Attorney",
      key: 7,
      backendName: "Power Of Attorney Divorce",
    },
    {
      title: "Healthcare Directives",
      key: 8,
      backendName: "Healthcare Directives Divorce",
    },
    {
      title: "Business Agreements",
      key: 9,
      backendName: "Business Agreements Divorce",
    },
    { title: "Court Orders", key: 10, backendName: "Court Orders Divorce" },
  ];

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Legal Documentation</h2>
            <ToolTipCreator name={"Divorce_Legal_Documentation"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      <div className="child-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="child-title">Marriage Documents</h2>
            <ToolTipCreator name={"Divorce_Marriage_Documents"}/>
        </div>
      </div>
      {marriageDocumentsTables.map((table) => {
        const moduleTitle = table.backendName || table.title;
        return (
          <CollapseableTable
            title={table.title}
            key={table.key}
            onClick={() => showModal(moduleTitle)}
          >
            <Table
              columns={AllColumnsData[moduleTitle]}
              dataSource={tableDataObj[moduleTitle]}
            />
          </CollapseableTable>
        );
      })}
         <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={handleImageUpload}
          loading={loading}
        />
      </div>

      <div className="child-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="child-title">Legal Records</h2>
        <ToolTipCreator name={"Divorce_Legal_Documentation_2"}/>
      </div>
      </div>
      {legalRecordsTables.map((table) => {
        const moduleTitle = table.backendName || table.title;
        return (
          <CollapseableTable
            title={table.title}
            key={table.key}
            onClick={() => showModal(moduleTitle)}
          >
            <Table
              columns={AllColumnsData[moduleTitle]}
              dataSource={tableDataObj[moduleTitle]}
            />
          </CollapseableTable>
        );
      })}

      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={handleImageUpload}
          loading={loading}
        />
         <NewLoader isLoading={loading} />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
}
